import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { t } from 'i18next';
import CustomFieldValues from '../util/CustomFieldValues';
import CalendarPicker from '../util/CalendarPicker';
import CategoryTaskPicker from '../timesheetsComp/CategoryTaskPicker';

interface TemporaryDrawerProps {
  setShow: any,
  refreshEquip: any,
  selectedUser: any,
  status: any,
  access: any
}

export default function EditEquipment({ setShow, refreshEquip, selectedUser, status, access }: TemporaryDrawerProps) {
  const [users, setUsers] = useState([]);
  const [patTest, setPatTest] = useState(false);
  const [capitalised, setCapitalised] = useState(false);
  const [user, setUser] = useState<any | null>(null);
  const [userPat, setUserPat] = useState<any | null>(null);
  const [userInventory, setUserInventory] = useState<any | null>(null);
  const handleClose = () => setShow(false);
  const [warDate, setWarDate] = useState<Date | null>(null);
  const [purchDate, setPurchDate] = useState<Date | null>(null);
  const [patTTDate, setPatTTDate] = useState<number | undefined>(undefined);
  const [months, setMonths] = useState('');
  const [rate, setRate] = useState<number | undefined>(undefined);
  const [patTDDate, setPatTDDate] = useState<Date | null>(null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [InventoryDate, setInventoryDate] = useState<Date | null>(null);
  const [location, setLocation] = useState<any | null>(null);
  const [locationAll, setLocationAll] = useState<any | null>(null);
  const [categoryEQ, setCategoryEQ] = useState<any | null>(null);
  const [categoryEQAll, setCategoryEQAll] = useState<any | null>(null);
  const [name, setName] = useState('');
  const [method, setMethod] = useState('');
  const [strand, setStrand] = useState('');
  const [addition, setAddition] = useState('');
  const [netValue, setNetValue] = useState('');
  const [disposed, setDisposed] = useState('');
  const [details, setDetails] = useState('');
  const [serial, setSerial] = useState('');
  const [manufacturer, setManufacturer] = useState('');
  const [model, setModel] = useState('');
  const [inventoryID, setInventoryID] = useState<number | null>(null);
  const [cost, setCost] = useState<string>('');
  const [statusQ, setStatusQ] = useState<number | null>(null);
  const [notes, setNotes] = useState('');
  const [rental, setRental] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleDateChange = (date: Date, set: React.Dispatch<React.SetStateAction<Date | null>>, type?: string) => {
    set(date);
  };

  const handleSelectChangeLocal = (event: any) => {
    setLocation(Number(event.target.value));
  };

  const handleSelectChangeStatus = (event: any) => {
    setStatusQ(Number(event.target.value));
  };

  const handleSelectChangeCategory = (event: any) => {
    setCategoryEQ(Number(event.target.value));
  };

  const handleSelectChangeUser = (event: any) => {
    setUser(Number(event.target.value));
  };

  const handleSelectChangePatUser = (event: any) => {
    setUserPat(Number(event.target.value));
  };

  const handleSelectChangeInventoryUser = (event: any) => {
    setUserInventory(Number(event.target.value));
  };

  const handleSelectChangeNumbers = (event: any) => {
    setInventoryID(event.target.value);
  };

  const handleSelectPaTT = (event: any) => {
    const newPatTTDate = Number(event.target.value);
    setPatTTDate(newPatTTDate);
    if (newPatTTDate === 0) {
      setPatTDDate(null);
      setUserPat(null);
    }
  };

  const handleSelectChangeCost = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setCost(value);
    }
  };

  const handleSelectChange = (event: any, set: React.Dispatch<React.SetStateAction<string>>) => {
    set(event.target.value);
  };

  const handleRentalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRental(event.target.checked);
  };

  const handlePatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPatTest(event.target.checked);
  };

  const handleCapitalisedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCapitalised(event.target.checked);
  };

  const calculatePatTestDueDate = (patTDDate: Date | null, patTTDate: number | undefined): string => {
    if (!patTDDate || patTTDate === undefined) return '';
    const dueDate = new Date(patTDDate);
    dueDate.setMonth(dueDate.getMonth() + (patTTDate || 0));
    return dueDate.toLocaleDateString('en-GB');
  };

  useEffect(() => {
    (async () => {
      if (selectedUser) {
        try {
          const { data } = await axios.get(`equipment/${selectedUser.id}`);
          const { data: Loc } = await axios.get(`location`);
          const { data: Cat } = await axios.get(`category-equipment`);
          if (Loc) {
            const activeLocation = Loc.filter((location: any) => location.active);
            setLocationAll(activeLocation);
          }
          if (Cat) {
            const activeCategory = Cat.filter((category: any) => category.active);
            setCategoryEQAll(activeCategory);
          }
          if (data) {
            setUsers(data.users);
            setLocation(data.equipment.locationId);
            setCategoryEQ(data.equipment.categoryEquipmentId);
            setName(data.equipment.item_name);
            setSerial(data.equipment.serial_number);
            setManufacturer(data.equipment.manufacturer);
            setModel(data.equipment.model);
            setInventoryID(data.equipment.inventory_id);
            setCost(data.equipment.cost);
            setNotes(data.equipment.notes);
            setUser(data.equipment.responsibleUserId);
            setUserPat(data.equipment.patUserId);
            setUserInventory(data.equipment.inventoryUserId);
            setRental(data.equipment.rental_opportunity);
            setWarDate(data.equipment.warranty ? new Date(data.equipment.warranty) : null);
            setPurchDate(data.equipment.purchase_date ? new Date(data.equipment.purchase_date) : null);
            setPatTTDate(data.equipment.pat_due);
            setPatTDDate(data.equipment.pat_date ? new Date(data.equipment.pat_date) : null);
            setInventoryDate(data.equipment.inventory_date ? new Date(data.equipment.inventory_date) : null);
            setStatusQ(data.equipment.statusId);
            setPatTest(data.equipment.pat_test);
            setCapitalised(data.equipment.capitalised);
            setMethod(data.equipment.depreciation_method);
            setStrand(data.equipment.funding_strand);
            setStartDate(data.equipment.depreciation_start_date);
            setMonths(data.equipment.depreciation_months);
            setRate(data.equipment.depreciation_rate);
            setAddition(data.equipment.additions);
            setNetValue(data.equipment.net_book_value);
            setDisposed(data.equipment.disposed_cost);
            setDetails(data.equipment.invoice_details);
          }
        } catch (e) {
        }
      }
    })();
  }, [selectedUser]);

  const handleEquipment = async () => {
    if (!categoryEQ) {
      enqueueSnackbar('Can not be none', { variant: 'error' });
      return;
    }

    if (name.trim() === '') {
      enqueueSnackbar('Name is empty', { variant: 'error' });
      return;
    }

    if (patTest && !patTDDate) {
      enqueueSnackbar('PAT date is required when PAT test is enabled', { variant: 'error' });
      return;
    }

    try {
      const equipmentData: any = {
        item_name: name,
        manufacturer,
        model,
        serial_number: serial,
        cost: Number(cost),
        notes,
        locationId: location,
        categoryEquipmentId: categoryEQ,
        responsibleUserId: user,
        purchase_date: purchDate,
        warranty: warDate,
        rental_opportunity: rental,
        inventory_id: inventoryID,
        capitalised
      };
      if (access.equipment_inventory_mode) {
        equipmentData.inventoryUserId = userInventory;
        equipmentData.inventory_date = InventoryDate;
        equipmentData.statusId = statusQ;
      }

      if (access.equipment_pat_test) {
        equipmentData.pat_test = patTest;
      }

      if (patTest) {
        equipmentData.pat_date = patTDDate;
        equipmentData.pat_due = patTTDate;
        equipmentData.patUserId = userPat;
      } else {
        equipmentData.pat_date = null;
        equipmentData.pat_due = 0;
        equipmentData.patUserId = null;
      }

      if (capitalised) {
        equipmentData.depreciation_method = method;
        equipmentData.funding_strand = strand;
        equipmentData.depreciation_start_date = startDate;
        equipmentData.depreciation_months = Number(months);
        equipmentData.depreciation_rate = rate;
        equipmentData.additions = addition;
        equipmentData.net_book_value = netValue;
        equipmentData.disposed_cost = disposed;
        equipmentData.invoice_details = details;
      } else {
        equipmentData.depreciation_method = null;
        equipmentData.funding_strand = null;
        equipmentData.depreciation_start_date = null;
        equipmentData.depreciation_months = 0;
        equipmentData.depreciation_rate = null;
        equipmentData.additions = null;
        equipmentData.net_book_value = null;
        equipmentData.disposed_cost = null;
        equipmentData.invoice_details = null;
      }

      await axios.put(`equipment/${selectedUser.id}`, equipmentData);
      handleClose();
      refreshEquip();
      enqueueSnackbar('Successfully', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Error creating', { variant: 'error' });
      console.error('Error creating:', error);
    }
  };

  useEffect(() => {
    if (patTTDate === 0) {
      setPatTDDate(null);
      setUserPat(null);
    }
  }, [patTTDate]);

  const catColor = selectedUser?.categoryEquipment?.color;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Header */}
      <div style={{ padding: '16px 20px 12px', borderBottom: '1px solid var(--border-input)', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
        <div style={{ width: 36, height: 36, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', background: catColor ? `${catColor}22` : 'rgba(245,158,11,.12)', fontSize: 18 }}>
          🖥
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-color)' }}>{name || t('EditEqp')}</div>
          <div style={{ fontSize: 11, color: 'var(--text-color-calendar-week)' }}>ID {inventoryID} · {selectedUser?.categoryEquipment?.name ?? ''}</div>
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 20px' }}>
        <div className='text-[var(--text-color)]'>
          <div className='flex flex-col justify-evenly flex-grow' >
            <h2 className='text-[14px] my-[5px] font-semibold text-right'>{t('ItemInfo')}</h2>
            <div>
              <div className='flex gap-[7px] w-full'>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('Name')}:</label>
                  <input
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    type="text"
                    placeholder={t('Name')}
                    value={name ? name : ''}
                    onChange={(e) => handleSelectChange(e, setName)} />
                </div>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('Serial Number')}:</label>
                  <input
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    type="text"
                    placeholder={t('SerialNumber')}
                    value={serial ? serial : ''}
                    onChange={(e) => handleSelectChange(e, setSerial)} />
                </div>
              </div>
              <div className='flex gap-[7px] w-full'>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('Manufacturer')}:</label>
                  <input
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    type="text"
                    placeholder={t('Manufacturer')}
                    value={manufacturer ? manufacturer : ''}
                    onChange={(e) => handleSelectChange(e, setManufacturer)} />
                </div>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('Model')}:</label>
                  <input
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    type="text"
                    placeholder={t('Model')}
                    value={model ? model : ''}
                    onChange={(e) => handleSelectChange(e, setModel)} />
                </div>
              </div>
              <div className='flex gap-[7px] w-full mb-[5px]'>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('Inventory ID')}:</label>
                  <input
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    type="text"
                    placeholder={t('InventoryID')}
                    value={inventoryID ? inventoryID : ''}
                    onChange={handleSelectChangeNumbers} />
                </div>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('Cost')}:</label>
                  <input
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    type="text"
                    placeholder={t('Cost')}
                    value={cost ? cost : ''}
                    onChange={handleSelectChangeCost} />
                </div>
              </div>
              <div className='flex gap-[7px] w-full mb-[5px]'>
                <div className='w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('ResponsibleForItem')}:</label>
                  <select
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    onChange={handleSelectChangeUser}
                    value={user ? user : 'none'}>
                    <option value="none">none</option>
                    {users.map((name: any) => (
                      <option key={name.id} value={name.id}>
                        {name.first_name} {name.last_name}
                      </option>))}
                  </select>
                </div>
              </div>
              <div className='w-full mb-[5px]'>
                <label className='text-[10px] ml-[5px]'>{t('Notes')}:</label>
                <textarea
                  title={t('Notes')}
                  placeholder={t('Notes')}
                  className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input resize-none'
                  value={notes || ''}
                  onChange={(e) => handleSelectChange(e, setNotes)}
                  rows={2}
                />
              </div>
              <div className='flex gap-[7px] w-full'>
                <div className='flex flex-col w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('PurchaseDate')}</label>
                  <CalendarPicker
                    mode="single"
                    variant="bare"
                    className="timesheets-input-all text-right text-[14px] w-full px-[5px] py-[4px] rounded-[5px]"
                    value={purchDate ? new Date(purchDate) : null}
                    onChange={(date: any) => handleDateChange(date, setPurchDate)}
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
                <div className='flex flex-col w-full'>
                  <label className='text-[10px] ml-[5px]'>{t('WarrantyDue')}</label>
                  <CalendarPicker
                    mode="single"
                    variant="bare"
                    className="timesheets-input-all text-right text-[14px] w-full px-[5px] py-[4px] rounded-[5px]"
                    value={warDate ? new Date(warDate) : null}
                    onChange={(date: any) => handleDateChange(date, setWarDate)}
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
              </div>
              <div className='w-full my-[5px]'>
                <label className='text-[10px] ml-[5px]'>{t('Location')}</label>
                <select
                  className='w-full edit-select py-[4px] px-[8px] rounded-[5px] edit-input'
                  onChange={handleSelectChangeLocal}
                  value={location || 'none'}>
                  <option value="none">none</option>
                  {locationAll?.map((location: any) => (
                    <option key={location.id} value={location.id}>
                      {location.name}
                    </option>))}
                </select>
              </div>
              <div className='w-full'>
                <label className='text-[10px] ml-[5px]'>{t('Category')}</label>
                <CategoryTaskPicker
                  nodes={(categoryEQAll || []).map((c: any) => ({ id: c.id, name: c.name }))}
                  selectedCategoryId={categoryEQ ? [Number(categoryEQ)] : []}
                  categoryName={[]}
                  onCategorySelect={(id) => setCategoryEQ(id === -1 ? null : id)}
                  selectedTasks={[]}
                  setSelectedTasks={() => {}}
                  taskOrTasks={false}
                  categoryOnly
                  block
                />
              </div>
            </div>
            <div className='flex flex-col justify-evenly flex-grow' >
              <hr className='hr mt-[10px]' />
              <div className='flex justify-between items-center'>
                <div className='flex justify-start items-center gap-2  ml-2'>
                  <input
                    type="checkbox"
                    title={t('PatTest')}
                    checked={patTest || false}
                    onChange={handlePatChange}
                    disabled={!access.equipment_pat_test} />
                  <label className='text-[16px]'>{t('PatTest')}</label>
                </div>
                <h2 className='text-[14px] my-[5px] font-semibold text-right mb-[10px]'>{t('PATInfo')}</h2>
              </div>
              {patTest ? (
                <div className='mb-[7px]'>
                  <div
                    className='flex gap-[10px] mt-[5px] items-center justify-end'>
                    <label
                      className='text-[15px]'>{t('SelectTheNumberOfMonths')}:</label>
                    <input
                      type="number"
                      title={t('SelectTheNumberOfMonths')}
                      placeholder="0"
                      className='w-[210px] mb-[10px] text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                      value={patTTDate ? patTTDate : 0}
                      min={0}
                      max={48}
                      disabled={!access.equipment_pat_test}
                      onChange={handleSelectPaTT} />
                  </div>
                  <div className='flex gap-[7px] w-full'>
                    <div className='flex flex-col w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('PATTestDate')}</label>
                      <CalendarPicker
                        mode="single"
                        variant="bare"
                        className="timesheets-input-all text-right text-[14px] w-full px-[5px] py-[4px] rounded-[5px]"
                        value={patTDDate ? new Date(patTDDate) : null}
                        onChange={(date: any) => handleDateChange(date, setPatTDDate, 'patTDDate')}
                        displayFormat="DD/MM/YYYY"
                        disabled={!access.equipment_pat_test}
                      />
                    </div>
                    <div className='flex flex-col w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('PATTestDue')}</label>
                      <input
                        type='text'
                        title={t('PATTestDue')}
                        placeholder="—"
                        value={calculatePatTestDueDate(patTDDate, patTTDate)}
                        className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                        disabled
                      />
                    </div>
                  </div>
                  <div className='my-[3px]'>
                    <label className='text-[10px] ml-[5px]'>{t('ResponsibleForPAT')}:</label>
                    <select
                      className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                      onChange={handleSelectChangePatUser}
                      disabled={!access.equipment_pat_test}
                      value={userPat ? userPat : 'none'}>
                      <option value="none">none</option>
                      {users.map((name: any) => (
                        <option key={name.id} value={name.id}>
                          {name.first_name} {name.last_name}
                        </option>))}
                    </select>
                  </div>
                </div>
              ) : null}
            </div>
            <div className='flex flex-col justify-evenly flex-grow mb-[10px]' >
              <hr className='hr' />
              <div className='flex justify-between items-center'>
                <div className='flex justify-start items-center gap-2 my-[5px] ml-2'>
                  <input
                    type="checkbox"
                    title={t('Capitalised')}
                    checked={capitalised || false}
                    onChange={handleCapitalisedChange} />
                  <label className='text-[16px]'>{t('Capitalised')}</label>
                </div>
                <h2 className='text-[14px] my-[5px] font-semibold text-right mb-[10px]'>{t('CapitalisedInfo')}</h2>
              </div>
              {capitalised ? (
                <>
                  <div className='flex gap-[7px] w-full mb-[10px]'>
                    <div className='w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('Method')}</label>
                      <select
                        className='w-full edit-select py-[4px] px-[8px] rounded-[5px] edit-input text-[14px]'
                        onChange={(e: any) => setMethod(e.target.value)}
                        disabled={!access.equipment_inventory_mode}
                        value={method || 'none'}>
                        <option value="none">none</option>
                        <option value="straight line">Straight Line</option>
                        <option value="reducing balance">Reducing Balance</option>
                      </select>
                    </div>
                    <div className='w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('Stand')}</label>
                      <input
                        type='text'
                        title={t('Stand')}
                        placeholder={t('Stand')}
                        value={strand || ''}
                        onChange={(e: any) => setStrand(e.target.value)}
                        className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                      />
                    </div>
                  </div>
                  <div className='flex gap-[7px] w-full mb-[10px]'>
                    <div className='flex flex-col w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('StartDate')}</label>
                      <CalendarPicker
                        mode="single"
                        variant="bare"
                        className="timesheets-input-all text-right text-[14px] w-full px-[5px] py-[4px] rounded-[5px]"
                        value={startDate ? new Date(startDate) : null}
                        onChange={(date: any) => handleDateChange(date, setStartDate)}
                        displayFormat="DD/MM/YYYY"
                      />
                    </div>
                    <div className='w-full flex gap-[7px] items-center'>
                      <div className='flex flex-col w-full'>
                        <label className='text-[10px] ml-[5px]'>{t('Months')}</label>
                        <input
                          type='text'
                          title={t('Months')}
                          placeholder="0"
                          value={months || ''}
                          onChange={(e: any) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.,]/g, '');
                            if ((value.match(/[.,]/g) || []).length > 1) {
                              value = value.slice(0, -1);
                            }
                            setMonths(value);
                          }}
                          className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                        />
                      </div>
                      <div className='flex flex-col w-full'>
                        <label className='text-[10px] ml-[5px]'>{t('Rate')}</label>
                        <input
                          type='text'
                          title={t('Rate')}
                          placeholder="0.00"
                          value={rate || ''}
                          onChange={(e: any) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.,]/g, '');
                            if ((value.match(/[.,]/g) || []).length > 1) {
                              value = value.slice(0, -1);
                            }
                            setRate(value);
                          }}
                          className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                        />
                      </div>
                    </div>
                  </div>
                  <div className='flex gap-[7px] w-full'>
                    <div className='flex flex-col w-full'>
                      <div className='flex flex-col w-full'>
                        <label className='text-[10px] ml-[5px]'>{t('Additions')}</label>
                        <input
                          type='text'
                          title={t('Additions')}
                          placeholder="0.00"
                          value={addition || ''}
                          onChange={(e: any) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.,]/g, '');
                            if ((value.match(/[.,]/g) || []).length > 1) {
                              value = value.slice(0, -1);
                            }
                            setAddition(value);
                          }}
                          className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                        />
                      </div>
                    </div>
                    <div className='flex flex-col w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('NetBookValue')}</label>
                      <input
                        type='text'
                        title={t('NetBookValue')}
                        placeholder="0.00"
                        value={netValue || ''}
                        onChange={(e: any) => {
                          let value = e.target.value;
                          value = value.replace(/[^0-9.,]/g, '');
                          if ((value.match(/[.,]/g) || []).length > 1) {
                            value = value.slice(0, -1);
                          }
                          setNetValue(value);
                        }}
                        className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                      />
                    </div>
                    <div className='flex flex-col w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('DisposedCost')}</label>
                      <input
                        type='text'
                        title={t('DisposedCost')}
                        placeholder="0.00"
                        value={disposed || ''}
                        onChange={(e: any) => {
                          let value = e.target.value;
                          value = value.replace(/[^0-9.,]/g, '');
                          if ((value.match(/[.,]/g) || []).length > 1) {
                            value = value.slice(0, -1);
                          }
                          setDisposed(value);
                        }}
                        className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                      />
                    </div>
                  </div>
                  <div className='flex flex-col justify-evenly flex-grow mb-[10px]' >
                    <div className='w-full'>
                      <label className='text-[10px] ml-[5px]'>{t('InvoiceDetails')}</label>
                      <input
                        type='text'
                        title={t('InvoiceDetails')}
                        placeholder={t('InvoiceDetails')}
                        value={details || ''}
                        onChange={(e: any) => setDetails(e.target.value)}
                        className="timesheets-input-all text-right text-[14px] w-full px-[8px] py-[4px] rounded-[5px]"
                      />
                    </div>
                  </div>
                </>
              ) : null}
              <div>
                <hr className='hr' />
                <h2 className='text-[14px] my-[5px] font-semibold text-right mb-[10px]'>{t('InventoryInfo')}</h2>
                <div className='flex gap-[7px] w-full'>
                  <div className='flex flex-col w-full'>
                    <label className='text-[10px] ml-[5px]'>{t('InventoryDate')}</label>
                    <CalendarPicker
                      mode="single"
                      variant="bare"
                      className="timesheets-input-all text-right text-[14px] w-full px-[5px] py-[4px] rounded-[5px]"
                      value={InventoryDate ? new Date(InventoryDate) : null}
                      onChange={(date: any) => handleDateChange(date, setInventoryDate, 'inventoryDate')}
                      displayFormat="DD/MM/YYYY"
                      disabled={!access.equipment_inventory_mode}
                    />
                  </div>
                  <div className='flex flex-col w-full'>
                    <label className='text-[10px] ml-[5px]'>{t('Status')}: </label>
                    <select
                      className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                      onChange={handleSelectChangeStatus}
                      disabled={!access.equipment_inventory_mode}
                      value={statusQ || 'none'}>
                      <option value="none">none</option>
                      {status?.map((status: any) => (
                        <option key={status.id} value={status.id}>
                          {status.name}
                        </option>))}
                    </select>
                  </div>
                </div>
                <div className='flex flex-col w-full mt-[7px]'>
                  <label className='text-[10px] ml-[5px]'>{t('InventoryUser')}:</label>
                  <select
                    className='w-full text-[14px] py-[4px] px-[8px] rounded-[5px] bg-[var(--bg-input)] text-[var(--text-color)] timesheet-edit-input'
                    onChange={handleSelectChangeInventoryUser}
                    disabled={!access.equipment_inventory_mode}
                    value={userInventory ? userInventory : 'none'}>
                    <option value="none">none</option>
                    {users.map((name: any) => (
                      <option key={name.id} value={name.id}>
                        {name.first_name} {name.last_name}
                      </option>))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <CustomFieldValues tableName="equipment" entityId={selectedUser.id} />
        </div>
      </div>
      {/* Footer */}
      <div style={{ padding: '12px 20px', borderTop: '1px solid var(--border-input)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <div style={{ fontSize: 11, color: 'var(--text-color-calendar-week)' }}>
          {selectedUser?.updatedAt
            ? `Last updated: ${new Date(selectedUser.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`
            : ''}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" className="eq-cancel" onClick={() => handleClose()}>{t('Cancel')}</button>
          <button type="button" className="eq-save" onClick={handleEquipment}>{t('Change')}</button>
        </div>
      </div>
    </div>
  )
}